module.exports = __webpack_public_path__ + "img/1-1P32Q1192I05.0d9138ac.png";